export const SET_DATA_REPORT = 'SET_DATA_REPORT';
export const SET_DATA_FILTER = 'SET_DATA_FILTER';
export const SET_ACTIVE_SAVE = 'SET_ACTIVE_SAVE';